import { INIT_PAGE_STATE } from "../../constant/constant";

export const SYNC_LOG_GET_LIST = "SYNC_LOG_GET_LIST";
export const SYNC_LOG_GET_LIST_SUCCESS = "SYNC_LOG_GET_LIST_SUCCESS";
export const SYNC_LOG_GET_LIST_ERROR = "SYNC_LOG_GET_LIST_ERROR";

export const loadSyncLogList = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      deleteFlag: false,
      orderBy: "id",
      sortedBy: "asc",
      limit: INIT_PAGE_STATE.pageSizes[0],
      startDate: null,
      endDate: null,
      // limit: 1,
    },
    ...p,
  };
  const payload = {
    municipal_id: param.sourced_id,
    selectedPage: param.selectedPage,
    filter: param.filter,
    deleteFlag: param.deleteFlag,
    orderBy: param.orderBy,
    sortedBy: param.sortedBy,
    limit: param.limit,
    startDate: param.startDate,
    endDate: param.endDate,
  };
  console.log('loadSyncLogList payload:', payload);
  return {
    type: SYNC_LOG_GET_LIST,
    payload,
  };
};

export const loadSyncLogListSuccess = (data) => ({
  type: SYNC_LOG_GET_LIST_SUCCESS,
  payload: data,
});

export const loadSyncLogListError = (error) => ({
  type: SYNC_LOG_GET_LIST_ERROR,
  payload: error,
});

